module.exports = __webpack_public_path__ + "fa248f03cb4dc294a087fb5a11515d52.MP3";